import SearcherTypes from 'searcher/searcher_types';
import { SearcherActions } from "searcher/reflux/searcher_store";
import LoadSearcherDataActionHandler from 'searcher/handlers/load_searcher_data_action_handler';
import SetMappedValuesActionHandler from 'searcher/handlers/set_mapped_values_action_handler';

export const execute = (action) => {
	const searcherHandler = getSearcherHandler(action);
	return searcherHandler(action);
};

const getSearcherHandler = (action) => {
	switch(action.searcherType) {
		case SearcherTypes.LOOKUP:
		return executeLookup;
		case SearcherTypes.REFRESH:
		return executeRefresh;
		default:
		return () => Promise.resolve();
	}
};

const executeLookup = (action) => {
	SearcherActions.openModal(action);
	return Promise.resolve();
};

const executeRefresh = (action) => {
	return LoadSearcherDataActionHandler.execute(action)
		.then(SetMappedValuesActionHandler.execute.bind(this, action));
};

export default {
	execute
};
